function isVisaIssueDateValid(issueDate: Date | null | undefined): boolean {
  if (issueDate == null) {
    return false;
  }

  const nowDate = new Date(Date.now());
  const minDate = new Date(nowDate.setUTCFullYear(nowDate.getFullYear() - 20));

  if (issueDate.getTime() < minDate.getTime()) {
    return false;
  }

  return true;
}

export default isVisaIssueDateValid;
